module.exports = __webpack_public_path__ + "assets/img/3adb99871d671c270a5f24f4ea39f67d.png";